// extracted by mini-css-extract-plugin
export default {"navbar":"Breadcrumb_navbar__fHNyG","dropdown":"Breadcrumb_dropdown__Guxiy"};